<template>
  <div>
    <div id="orderCenter">
      <div class="himgWrap">
        <div class="firstInfo">
          <div class="oneTitle">订货中心
            <img src="@/assets/images/mall/dhzx.png" alt="" class="imgInfo">
          </div>
          <div class="orderStore">
            <div class="searchWrap">
              <el-input v-model="searchInfo" placeholder="搜索你想要找的店铺或商品" class="input-with-select">
                <el-button slot="append" icon="el-icon-search" @click="searchStore"></el-button>
              </el-input>
            </div>
            <span class="btns" @click="goOrder">我的订单</span>
            <span class="btns btns2" @click="goCreditStore">店铺数字权益</span>
          </div>
        </div>
      </div>
      <div class="contentInfo">
        <div class="storeList">
          <div v-for="(item,index) of areaList" :key="index" class="itemStore">
            <div class="storeInfo">
              <div class="topStore">
                <img :src="item.logoUrl" alt="" class="imgStore" @click="viewMore(item)">
                <div class="rightStore">
                  <div class="flexSty">
                    <p class="name" @click="viewMore(item)">{{ item.storeName }}</p>
                    <p class="constrc" @click="showPhone(item.note)">联系商家</p>
                  </div>
                  <div class="flexBtSty">
                    <div class="storeDesc">
                      {{ item.detail }}
                    </div>
                    <div v-if="item.commodityList.length>6" class="mores" @click="viewMore(item)">
                      查看更多&nbsp;<i class="el-icon-d-arrow-right"></i>
                    </div>
                  </div>

                </div>
              </div>

            </div>
            <div v-if="item.commodityList.length>0" class="goodInfo">
              <div class="goodList">
                <div v-for="(items,indexs) of item.commodityList.slice(0,6)" :key="indexs" class="goodStys" :class="{'maTop':indexs>=6}">
                  <div class="goodItem" @click="goDetail(item,items.commodityId)">
                    <img :src="items.goodImg" alt="" class="goodImg">
                    <img v-if="items.isSale" src="../../assets/images/mall/ysq.png" alt="已售罄" class="saleAll">
                    <div class="name"> {{ items.commodityName }}</div>
                    <p v-if="items.rewardRate!=0" class="marketPWrap">
                      赠送<span>{{ items.rewardRate }}%</span>店铺数字权益
                    </p>
                    <p v-else-if="items.specialHint" class="marketPWrap">
                      {{ items.specialHint }}
                    </p>
                    <p class="priceWrap">
                      <span v-if="items.purchasePrice==-1"><i>零售价</i><i class="utils">¥</i><i class="price">{{ items.retailPrice }}</i></span>
                      <span v-else><i>采购价</i><i class="utils">¥</i><i class="price">{{ items.purchasePrice }}</i></span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-row v-if="pageData.total">
          <el-col :span="24" class="paginateWrap">
            <el-pagination
              popper-class="_popStyle"
              :current-page="pageData.currentPage"
              :page-sizes="pageData.pageSizes"
              :page-size="pageData.pageSize"
              layout="total, sizes, prev, pager, next"
              :total="pageData.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
    <contractInfo ref="contrantRef" />
  </div>

</template>
<script>
/*global protocol http */
import contractInfo from '@/components/contractInfo/contractInfo.vue'
export default {
  components: {
    contractInfo
  },
  data() {
    return {
      searchInfo: null,
      areaList: [],
      chooseStoreId: null,
      shopTitle: '',
      contentList: [],
      goodList: [],
      sort: [{
        'direction': 'ASC',
        'property': 'sortId'
      }],
      // 分页相关
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 10,
        currentPage: 1
      },
      isNetWrong: false,
      userPrice: 'retailPrice' // 当前用户是零售价还是采购价用于排序
    }
  },
  mounted() {
    this.getClasssfiyShop()
  },
  methods: {
    showPhone(phones) {
      this.$refs.contrantRef.openDialog(phones)
    },
    viewMore(item) {
      const obj = {
        logoUrl: item.logoUrl,
        storeName: item.storeName,
        note: item.note,
        detail: item.detail,
        storeId: item.storeId
      }
      sessionStorage.setItem('storeInfo', JSON.stringify(obj))
      this.$router.push('/storeDetail')
    },
    searchStore() {
      this.pageData.currentPage = 1
      this.areaList = []
      this.getClasssfiyShop()
    },
    getClasssfiyShop() {
      protocol.param_findGstShop.param.page = this.pageData.currentPage - 1
      protocol.param_findGstShop.param.size = this.pageData.pageSize
      protocol.param_findGstShop.param.queryName = this.searchInfo ? this.searchInfo : null
      protocol.param_findGstShop.param.mallFlag = 'S'
      protocol.param_findGstShop.param.sort = [{
        'direction': 'ASC',
        'property': 'sortId'
      }]
      http.postFrontMall(protocol.param_findGstShop).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          this.pageData.total = value.totalElements
          this.isNetWrong = false
          for (let j = 0; j < value.content.length; j++) {
            // 测试数据
            // const itemLists = [...value.content[j].commodityList, ...value.content[j].commodityList]
            // const itemList55 = [...itemLists, ...itemLists]
            // const itemList = [...itemList55, ...itemList55]
            const itemList = value.content[j].commodityList
            for (let i = 0; i < itemList.length; i++) {
              const item = itemList[i]
              const rates = item.retailPrice === -1 ? item.purchaseRate : item.retailRate
              const newObj = {
                commodityName: item.commodityName,
                commodityId: item.commodityId,
                price: item.price,
                marketPrice: item.skus[0].skuPrice,
                goodInfo: item.skus[0],
                retailPrice: item.retailPrice,
                purchasePrice: item.purchasePrice,
                goodImg: '',
                sortId: item.sortId,
                isSale: Number(item.reserve) <= 0,
                rewardRate: rates * 100,
                specialHint: item.specialHint
              }
              for (let m = 0; m < item.imgs.length; m++) {
                if (item.imgs[m].isMain === '1') {
                  newObj.goodImg = item.imgs[m].img
                }
              }
              value.content[j].commodityList[i] = newObj
            }
            value.content[j].activeSort = 'sortId'
          }
          if (value.totalElements > 0 && value.content[0].commodityList.length > 0) {
            this.userPrice = value.content[0].commodityList[0].purchasePrice == -1 ? 'retailPrice' : 'purchasePrice'
          }
          this.areaList = value.content
        } else {
          this.isNetWrong = true
          this.areaList = []
          this.$message(message)
        }
      }).catch(() => {

      })
    },
    goDetail(item, id) {
      const obj = {
        logoUrl: item.logoUrl,
        storeName: item.storeName,
        note: item.note,
        detail: item.detail,
        storeId: item.storeId
      }
      sessionStorage.setItem('storeInfo', JSON.stringify(obj))
      this.$router.push({
        name: 'productDetail',
        params: {
          commodityId: id
        }
      })
    },
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.getClasssfiyShop()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.getClasssfiyShop()
    },
    goGoodDetail(id) {
      sessionStorage.setItem('toAddress', 3) // 清空选择的地址
      this.$router.push({
        name: 'productDetail',
        params: {
          commodityId: id
        }
      })
    },
    goCreditStore() {
      this.$router.push('/creditStore')
    },
    goOrder() {
      this.$router.push({
        name: 'reportSystem',
        params: {
          id: 1
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
#orderCenter{
    position: relative;
    background: #292C3A;
    min-height: 100vh;
  .himgWrap{
     width:100vw;
     min-width: 1200px;
     height: 87px;
     background: #3B3E4E;
    .firstInfo{
      width: 1200px;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin:0 auto;
    }
     .oneTitle{
      font-size: 28px;
      font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
      font-weight: 500;
      color: #FFFFFF;
      position: relative;
      .imgInfo{
        position: absolute;
        width: 55px;
        left: calc(50% - 23px);
        top: -4px;
      }
     }
     .orderStore{
      display: flex;
      justify-content: flex-end;
      .searchWrap /deep/.el-input__inner{
        width: 240px;
        height: 35px;
        border-radius: 4px 0px 0px 4px;
        background:transparent;
        border: 1px solid #A5A6AC;
        font-size: 14px;
        font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
        font-weight: 400;
        color: #B6BDCC;
        box-sizing: border-box;
      }
      /deep/.el-input-group__append{
        width:60px;
        height: 35px;
        border:none;
        padding: 0;
        background: #A5A6AC;
        color:#fff;
        text-align: center;
        .el-icon-search{
          color:#fff;
        }
      }
      .btns{
        cursor: pointer;
        display: inline-block;
        width: 83px;
        height: 32px;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #D9D9D9;
        // box-sizing: border-box;
        text-align: center;
        font-size: 16px;
        font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 33px;
        margin-left:16px;
      }
      .btns2{
        width:114px;
      }
     }
  }
  .contentInfo{
    width:1200px;
    margin:0 auto;
    position: relative;
  }
  .storeList{
    min-height:670px;
    .itemStore{
      padding:30px 0;
      border-bottom: 2px solid #3B3E4E;
    }
    .storeInfo{
      .topStore{
        display: flex;
        align-items: center;
        .imgStore{
          width: 60px;
          height: 60px;
          border-radius: 43px 43px 43px 43px;
          margin-right: 13px;
          cursor: pointer;
        }
        .rightStore{
          width:calc(100% - 73px);
        }
        .flexSty{
          display: flex;
          align-items: center;
        }
        .flexBtSty{
          margin-top:10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .name{
          font-size: 20px;
          font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
          font-weight: 500;
          color: #C99F62;
          line-height: 23px;
          cursor: pointer;
        }
        .constrc{
          margin-left:6px;
          width: 60px;
          height: 20px;
          background: #76634D;
          border-radius: 4px 4px 4px 4px;
          font-size: 12px;
          font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
          font-weight: 500;
          color: #DECAA2;
          line-height: 20px;
          text-align: center;
          cursor: pointer;
        }
      }
      .storeDesc{
        width:1000px;
        font-size: 12px;
        font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 14px;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1; /* 这里是超出几行省略 */
        overflow: hidden;
      }
      .mores{
        width:100px;
        text-align: right;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 14px;
        cursor: pointer;
        /deep/.el-icon-d-arrow-right{
          color:#fff;
        }
      }
    }
    // .goodInfo{
    //   width: 880px;
    // }
    .topGood{
      display: flex;
      justify-content: space-between;
      align-items: center;
      p{
        font-size: 18px;
        font-family: PingFang HK-Regular, PingFang HK;
        font-weight: 400;
        color: #FFFFFF;
        position: relative;
        cursor: pointer;
      }
      /deep/.el-icon-caret-top{
        position: absolute;
        font-size:16px;
        top: 0px;
        color: #FFFFFF;
      }
      /deep/.el-icon-caret-bottom{
        position: absolute;
        font-size:16px;
        bottom: 0px;
        color: #FFFFFF;
      }
      /deep/.el-icon-d-arrow-right{
        color:#fff;
      }
    }
    .goodList{
      display: flex;
      flex-wrap: wrap;
      position: relative;
      .goodStys{
        margin-right: 24px;
      }
      .maTop{
        margin-top:30px;
      }
      .goodItem{
        margin-top:22px;
        width: 180px;
        height: 278px;
        background: #3B3E4E;
        padding:10px;
        box-sizing: border-box;
        cursor: pointer;
        position: relative;
      }
      .goodStys:nth-child(6n){
        margin-right: 0px;
      }
      .goodImg{
        width: 158px;
        height: 158px;
      }
      .saleAll{
        position: absolute;
        width: 52%;
        max-height: 46%;
        right: 10px;
        top: 88px;
      }
      .name{
        margin-top:10px;
        height: 32px;
        // font-size: 16px;
        // font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
        // font-weight: 500;
        color: #FFFFFF;
        font-size: 14px;
        font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
        font-weight: 500;
        line-height: 16px;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /* 这里是超出几行省略 */
        overflow: hidden;
      }
      .goodItem:hover {
        transform: translateY(-4px);
        transition-duration:1s;
        box-shadow: 2px 2px 2px 2px #171B2F;
        .name{
          color: #E4CA91;
        }
      }
      // .goodItem:hover img{
      //   transform: scale(0.8);
      // }
      // .name:hover{
      //   color: #C99F62;
      // }
      .marketPWrap{
        margin-top:14px;
        font-size: 14px;
        font-family: ITC Avant Garde Gothic Pro-Medium, ITC Avant Garde Gothic Pro;
        font-weight: 500;
        color: #9A9A9A;
        line-height: 19px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        span{
          font-size: 16px;
          color:#CCCCCC;
        }
      }
      .priceWrap{
        margin-top:5px;
        font-size: 14px;
        font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
        font-weight: 500;
        color: #B0B8DB;
        line-height: 19px;
        i{
          font-style: normal;
          color:#9A9A9A;
        }
        .utils{
          font-size: 14px;
          font-family: ITC Avant Garde Gothic Pro-Demi, ITC Avant Garde Gothic Pro;
          font-weight: bold;
          color: #E4CA91;
          line-height: 19px;
        }
        .price{
          font-size: 20px;
          font-weight: bold;
          color: #E4CA91;
        }
      }
    }
    .twoStyleRow{
      height:30px;
      position: absolute;
      top: 280px;
      .iconWrap{
          /deep/.el-icon-arrow-left{
            font-size:26px;
            color:#fff;
            font-weight: bold;
            cursor: pointer;
            position: absolute;
            left: -30px;
            top:15px;
          }
          /deep/.el-icon-arrow-right{
            font-size:26px;
            color:#fff;
            font-weight: bold;
            cursor: pointer;
            position: absolute;
            right: -30px;
            top:15px;
          }
        }
      .bottomLine{
        width:880px;
        height: 2px;
        background: #3B3E4E;
        margin-top:28px;
      }
    }
  }
}
</style>

